import React, { useRef, useEffect, useState } from 'react'
import { SDrawerOrModal, SLowcodeList, STableActions, SActionBtn, SAlert } from 'shj-components'
import { Form, TreeSelect, Radio, Select, Button, Input, Space, message } from 'antd'
import { ExclamationCircleOutlined } from '@ant-design/icons'
import {
  prodCombCreateTypeEnum,
  getSpuCachePage,
  getCacheSpuSerListBySpuId,
  saveMaterialAndProdSerCache,
  materialToProdCombSubmit,
  cleanMaterialToProdCombCache,
} from '@/services/mpms.ts'
import { config } from './config'
import {
  getProductCategoryTreeList,
  getProductEnums,
  getSpecialCodesList,
} from '@/services/product'
import styles from './index.module.less'
import _ from 'lodash'

export default function ContentModal({
  onClose = () => {},
  checkSubmit = () => ({}),
  submit = (a, b, c, d, e) => {},
  open = false,
  reload = () => {},
  totalCount = 0,
}) {
  const [buttonLoading, setButtonLoading] = useState(false)
  const [serviceLoading, setServiceLoading] = useState(false)
  const [checkLoading, setCheckLoading] = useState(false)
  const [categoryTree, setCategoryTree] = useState([])
  const [specialCodeList, setSpecialCodeList] = useState([])
  const [openCheckModal, setOpenCheckModal] = useState(false)
  const [openServiceModal, setOpenServiceModal] = useState(false)
  const [nameEnums, setNameEnums] = useState([])
  const [cacheTag, setCacheTag] = useState('')
  const [serviceSpuId, setServiceSpuId] = useState('')
  const [serviceList, setServiceList] = useState([])
  const [applyMaterialList, setApplyMaterialList] = useState([])

  const [form] = Form.useForm()
  const [checkForm] = Form.useForm()

  const listRef = useRef()

  const prodType = Form.useWatch('prodType', form)
  const prodCombCreateType = Form.useWatch('prodCombCreateType', checkForm)

  useEffect(() => {
    fetchEnumData()
  }, [])

  const fetchEnumData = async () => {
    try {
      const productCategory: any = await getProductCategoryTreeList({
        enabled: true,
        modeFlags: [4],
      })
      const list: any = (await getSpecialCodesList({ data: {} })) || []
      const nameRes: any = await prodCombCreateTypeEnum()
      const applyMaterialList: any = await getProductEnums(
        'com.shj.saas.plus.product.enums.ApplyMaterialSelection'
      )
      const specialCodeList = list.map((item: any) => {
        return { label: item.code + '-' + item.name, value: item.code }
      })
      setSpecialCodeList(specialCodeList)
      if (productCategory) {
        const newTree = formatTreeData(productCategory)
        setCategoryTree(newTree)
      }
      if (nameRes?.length) {
        const formatRes = nameRes.map((item: any) => ({ value: item.key, label: item.description }))
        setNameEnums(formatRes)
      }
      if (applyMaterialList?.length) {
        const list = applyMaterialList.map((item: any) => ({
          value: item.key,
          label: item.description,
        }))
        setApplyMaterialList(list)
        shopsControl(['NO_LIMIT'], list)
      }
    } catch (err) {
      console.log(err)
    }
  }

  const formatTreeData = (list: any) => {
    return list.map((item: any) => {
      if (item?.children?.length) {
        return {
          ...item,
          children: formatTreeData(item?.children),
          selectable: false,
        }
      } else {
        return {
          ...item,
          selectable: true,
        }
      }
    })
  }

  const onSubmit = () => {
    form.validateFields().then(async (value: any) => {
      setButtonLoading(true)
      await submit(
        value?.id,
        value?.grossRate,
        value?.specialCode,
        value?.prodType,
        value?.applyMaterialSelections
      )
      setButtonLoading(false)
    })
  }

  const checkCombination = () => {
    form.validateFields().then(async () => {
      const tag: any = await checkSubmit()
      if (!tag) {
        return
      }
      setCacheTag(tag)
      setOpenCheckModal(true)
    })
  }

  const fetchList = async ({ current = 1, query }) => {
    try {
      const res = await getSpuCachePage({
        params: {
          current,
          pageSize: 10,
        },
        data: {
          batchKey: cacheTag,
          name: query.nameKeyword,
          code: query.code,
        },
      })
      if (res) {
        return {
          records: res?.list,
          total: res?.count,
        }
      }
      return {
        records: [],
        total: 0,
      }
    } catch (err) {
      console.log(err)
    }
  }

  const openService = async (record: any) => {
    try {
      const serviceRes: any = await getCacheSpuSerListBySpuId({
        spuId: record.id,
        batchKey: cacheTag,
      })
      if (serviceRes?.spuSerAttrList?.length) {
        setServiceList(serviceRes?.spuSerAttrList)
        setServiceSpuId(record.id)
        setOpenServiceModal(true)
      }
    } catch (err) {
      console.log(err)
    }
  }

  const selectService = (e, code) => {
    const newList: any = serviceList?.map((service: any) => {
      if (service.constructionItemCode === code) {
        return {
          ...service,
          spuSerAttrOptionList: service.spuSerAttrOptionList?.map((attr: any) => {
            if (attr.constProdId === e?.target?.value) {
              return {
                ...attr,
                selected: true,
              }
            }
            return {
              ...attr,
              selected: false,
            }
          }),
        }
      }
      return {
        ...service,
      }
    })
    setServiceList(newList)
  }

  const onSubmitService = async () => {
    try {
      const res = await saveMaterialAndProdSerCache({
        batchKey: cacheTag,
        spuId: serviceSpuId,
        spuSerAttrList: serviceList,
      })
      if (res) {
        message.success(res.message)
        setOpenServiceModal(false)
      }
    } catch (err) {
      console.log(err)
    }
  }

  const onSubmitCheck = async () => {
    checkForm?.validateFields()?.then(async value => {
      try {
        const formValue = form.getFieldsValue()
        const res = await materialToProdCombSubmit({
          batchKey: cacheTag,
          prodCatId: formValue.id,
          specialCode: formValue.specialCode,
          applyMaterialSelections: formValue.applyMaterialSelections,
          prodType: 'PRODUCT_COMBINATION',
          ...value,
        })
        if (res) {
          message.success(res.message)
          setOpenCheckModal(false)
          onClose()
          reload()
        }
      } catch (err) {
        console.log(err)
      }
    })
  }

  const handleChangeCate = (_, node) => {
    if (node?.specialCode) {
      form.setFields([
        {
          name: 'specialCode',
          value: node.specialCode,
          errors: [],
        },
      ])
    }
  }

  // 右侧表格配置
  const extensions = {
    request: { fetchList },
    customRender: {
      actionRender(_, record) {
        return (
          <STableActions>
            <SActionBtn onClick={() => openService(record)}>服务设置</SActionBtn>
          </STableActions>
        )
      },
    },
  }
  const shopsControl = (value: any, list?: Array<any>) => {
    let newOption: any = _.cloneDeep(list || applyMaterialList)
    if (value?.length) {
      if (value.includes('NO_LIMIT')) {
        newOption = newOption.map((item: any) => {
          return {
            ...item,
            disabled: item.value !== 'NO_LIMIT',
          }
        })
      } else {
        newOption = newOption.map((item: any) => {
          return {
            ...item,
            disabled: item.value === 'NO_LIMIT',
          }
        })
      }
    } else {
      newOption = newOption.map((item: any) => {
        return {
          ...item,
          disabled: false,
        }
      })
    }
    setApplyMaterialList(newOption)
  }
  return (
    <div className={styles.settlementQuotaConfig}>
      <SDrawerOrModal
        title={'选择产品分类'}
        mode="modal"
        open={open}
        onCancel={() => onClose()}
        loading={buttonLoading}
        antdProps={{
          footer: (
            <div>
              <Button style={{ marginRight: '10px' }} onClick={() => onClose()}>
                取消
              </Button>
              {prodType === 'PRODUCT_COMBINATION' ? (
                <Button loading={buttonLoading} type="primary" onClick={checkCombination}>
                  组合检查
                </Button>
              ) : (
                <Button loading={buttonLoading} type="primary" onClick={onSubmit}>
                  提交
                </Button>
              )}
            </div>
          ),
        }}
        width="500px"
      >
        {totalCount > 0 && <SAlert type="info">将{totalCount}条物料数据提交到产品库</SAlert>}
        <Form
          form={form}
          labelCol={{
            span: 12,
          }}
          style={{
            paddingTop: '12px',
          }}
          layout="vertical"
          name="basicInfo"
        >
          <Form.Item
            name="id"
            label="产品分类"
            rules={[
              {
                required: true,
                message: '请选择产品分类',
              },
            ]}
          >
            <TreeSelect
              placeholder="请选择产品分类"
              treeData={categoryTree}
              fieldNames={{
                label: 'cateName',
                value: 'id',
              }}
              onSelect={handleChangeCate}
              treeNodeFilterProp="cateName"
              showSearch
            />
          </Form.Item>
          <Form.Item
            label={'特项代码'}
            name={'specialCode'}
            rules={[
              {
                required: true,
                message: '请选择特项代码',
              },
            ]}
            extra="说明：物料/施工已有特项代码的，该位置可不选择，系统会自动同步特项代码"
          >
            <Select
              showArrow
              showSearch
              placeholder="请选择特项代码"
              options={specialCodeList}
              optionFilterProp="label"
            />
          </Form.Item>
          <Form.Item
            label={'产品类型'}
            name={'prodType'}
            rules={[
              {
                required: true,
                message: '请选择产品类型',
              },
            ]}
            initialValue={'PRODUCT_BASIC_ITEM'}
            extra={
              prodType === 'PRODUCT_BASIC_ITEM'
                ? '说明：非零售产品'
                : prodType === 'PRODUCT_COMBINATION'
                  ? '说明：已关联服务的物料发布成组合产品（关联服务需要已转成产品）'
                  : ''
            }
          >
            <Radio.Group
              options={[
                { value: 'PRODUCT_BASIC_ITEM', label: '基础项' },
                { value: 'PRODUCT_SINGLE', label: '单品' },
                { value: 'PRODUCT_COMBINATION', label: '组合' },
              ]}
            />
          </Form.Item>
          <Form.Item
            label={'适用选材'}
            name={'applyMaterialSelections'}
            initialValue={['NO_LIMIT']}
          >
            <Select
              showArrow
              showSearch
              placeholder="请选择适用选材"
              options={applyMaterialList}
              optionFilterProp="label"
              mode="multiple"
              onChange={(value, option) => {
                shopsControl(value)
              }}
            />
          </Form.Item>
        </Form>
      </SDrawerOrModal>

      {openCheckModal ? (
        <SDrawerOrModal
          title={'组合检查'}
          mode="drawer"
          open={openCheckModal}
          onCancel={() => {
            setOpenCheckModal(false)
            checkForm.resetFields()
            cleanMaterialToProdCombCache({ batchKey: cacheTag })
          }}
          loading={checkLoading}
          antdProps={{
            footer: (
              <div>
                <Button style={{ marginRight: '10px' }} onClick={() => setOpenCheckModal(false)}>
                  取消
                </Button>
                <Button loading={checkLoading} type="primary" onClick={onSubmitCheck}>
                  提交
                </Button>
              </div>
            ),
          }}
          width="70%"
        >
          <Form
            form={checkForm}
            labelCol={{
              span: 12,
            }}
            style={{
              paddingTop: '12px',
              paddingLeft: '15px',
            }}
            layout="vertical"
            name="basicInfo"
          >
            <Form.Item
              label={'组合产品名称生成方式'}
              name={'prodCombCreateType'}
              initialValue={nameEnums?.[0]?.value}
              rules={[
                {
                  required: true,
                  message: '请选择组合产品名称生成方式',
                },
              ]}
            >
              <Radio.Group options={nameEnums} />
            </Form.Item>
            {prodCombCreateType === nameEnums?.[1]?.value ? (
              <Form.Item
                label={'自定义拼接文案'}
                name={'customizeStr'}
                rules={[
                  {
                    required: true,
                    message: '请输入自定义拼接文案',
                  },
                ]}
              >
                <Input placeholder="请输入自定义拼接文案" maxLength={15} style={{ width: '50%' }} />
              </Form.Item>
            ) : null}
          </Form>
          <div style={{ paddingLeft: 10, backgroundColor: '#fff', color: 'gray' }}>
            <ExclamationCircleOutlined style={{ margin: '0px 5px', color: '#1677FF' }} />
            以下物料关联的服务，关联多个有效产品，请选择需要关联的产品。不选则由系统默认选中一条。
          </div>
          <SLowcodeList ref={listRef} searchMode="group" config={config} {...extensions} />
        </SDrawerOrModal>
      ) : null}

      {openServiceModal && (
        <SDrawerOrModal
          title={'服务设置'}
          mode="modal"
          open={openServiceModal}
          onCancel={() => setOpenServiceModal(false)}
          onOk={onSubmitService}
          loading={serviceLoading}
          width="500px"
        >
          <div style={{ backgroundColor: '#fff', color: 'gray' }}>
            <ExclamationCircleOutlined style={{ margin: '0px 5px 10px 0', color: '#1677FF' }} />
            服务关联多个有效产品，请选择。
          </div>
          {serviceList?.length
            ? serviceList.map((service: any) => {
                return (
                  <div style={{ marginTop: 20 }}>
                    <div style={{ fontWeight: 500 }}>{service.constructionItemName}</div>
                    <div style={{ fontWeight: 500 }}>{service.constructionItemCode}</div>
                    {service?.spuSerAttrOptionList?.length ? (
                      <Radio.Group
                        style={{ marginTop: 10 }}
                        onChange={e => selectService(e, service.constructionItemCode)}
                        value={
                          service?.spuSerAttrOptionList?.filter(item => item.selected)?.[0]
                            ?.constProdId
                        }
                      >
                        <Space direction="vertical">
                          {service?.spuSerAttrOptionList.map((attr: any) => {
                            return <Radio value={attr.constProdId}>{attr.constProdName}</Radio>
                          })}
                        </Space>
                      </Radio.Group>
                    ) : null}
                  </div>
                )
              })
            : null}
        </SDrawerOrModal>
      )}
    </div>
  )
}
